// Media types (matching Flutter)
export enum MediaType {
    IMAGE = 0,
    VIDEO = 1,
}